import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator, enableNetwork, disableNetwork } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Firebase configuration with fallback values
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyANBg6O_VRUN_3ctnOHkh9uW6osmQr908w",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "fulcrum-41e50.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "fulcrum-41e50",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "fulcrum-41e50.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "493797920027",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:493797920027:web:8a060f0a3b20e2ddae17be"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Connection error handling and retry logic
let connectionRetryCount = 0;
const maxRetries = 3;

export const handleFirestoreConnection = async () => {
  try {
    await enableNetwork(db);
    connectionRetryCount = 0;
    } catch (error) {
    console.error('Firestore connection error:', error);
    connectionRetryCount++;
    
    if (connectionRetryCount < maxRetries) {
      setTimeout(() => {
        handleFirestoreConnection();
      }, 2000 * connectionRetryCount); // Exponential backoff
    } else {
      console.error('Max retries reached for Firestore connection');
    }
  }
};

// Initialize connection handling
handleFirestoreConnection();

// Add error listeners
auth.onAuthStateChanged((user) => {
  if (user) {
    handleFirestoreConnection();
  }
});

export default app;
